
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import Card from '../../components/base/Card';

export default function Home() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: "Shree Govardhan Chemicals",
      subtitle: "Manufacturer of Light Magnesium Carbonate (MgCO3)",
      description: "Leading manufacturer with state-of-the-art production facility",
      image: "https://readdy.ai/api/search-image?query=macro%20shot%20of%20white%20magnesium%20carbonate%20powder%20with%20soft%20lighting%2C%20laboratory%20setting%2C%20high%20purity%20chemical%20powder%2C%20clean%20white%20background%2C%20professional%20industrial%20photography%2C%20crystalline%20texture%2C%20fine%20powder%20particles&width=1920&height=1080&seq=hero-bg-1&orientation=landscape"
    },
    {
      title: "Quality Manufacturing",
      subtitle: "SAFETY FIRST – QUALITY OF PRODUCTION MUST",
      description: "Advanced infrastructure and strict quality assurance standards",
      image: "https://readdy.ai/api/search-image?query=modern%20chemical%20manufacturing%20plant%20with%20safety%20equipment%2C%20quality%20control%20laboratory%2C%20industrial%20machinery%2C%20professional%20workers%20in%20protective%20gear%2C%20clean%20production%20environment%2C%20Gujarat%20industrial%20facility&width=1920&height=1080&seq=hero-bg-2&orientation=landscape"
    },
    {
      title: "Trusted Excellence",
      subtitle: "Serving Industries Across India",
      description: "Reliable supply chain and customer-centric approach",
      image: "https://readdy.ai/api/search-image?query=chemical%20laboratory%20with%20testing%20equipment%2C%20quality%20analysis%2C%20scientific%20instruments%2C%20professional%20chemist%20working%2C%20industrial%20grade%20materials%2C%20precision%20manufacturing%20process&width=1920&height=1080&seq=hero-bg-3&orientation=landscape"
    }
  ];

  useEffect(() => {
    setIsVisible(true);
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const highlights = [
    {
      icon: 'ri-factory-line',
      title: 'Manufacturer',
      description: 'Trusted Production Excellence'
    },
    {
      icon: 'ri-flask-line',
      title: 'Light Magnesium Carbonate',
      description: 'High Purity Industrial Grade'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Contact Us',
      description: 'Reliable and Personalized Support'
    },
    {
      icon: 'ri-apps-line',
      title: 'Wide Applications',
      description: 'Rubber, Inks, Glass, Cosmetics, Cables and More'
    }
  ];

  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Quality Assurance',
      description: 'Rigorous testing and quality control at every stage of production'
    },
    {
      icon: 'ri-truck-line',
      title: 'Reliable Supply',
      description: 'Consistent delivery and distribution network across India'
    },
    {
      icon: 'ri-team-line',
      title: 'Expert Team',
      description: 'Highly qualified professionals committed to excellence'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Modern Infrastructure',
      description: 'Advanced machinery and well-equipped production facility'
    }
  ];

  const applications = [
    { name: 'Rubber Industry', icon: 'ri-car-line' },
    { name: 'Cosmetics', icon: 'ri-heart-line' },
    { name: 'Paints & Coatings', icon: 'ri-brush-line' },
    { name: 'Plastics', icon: 'ri-recycle-line' },
    { name: 'Paper Industry', icon: 'ri-file-paper-line' },
    { name: 'Sports Equipment', icon: 'ri-basketball-line' }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section with Slider */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
            style={{
              backgroundImage: `linear-gradient(rgba(0, 62, 126, 0.7), rgba(0, 62, 126, 0.5)), url('${slide.image}')`
            }}
          />
        ))}
        
        <div className="container mx-auto px-6 text-center text-white relative z-10">
          <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h1 className="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent">
              {slides[currentSlide].title}
            </h1>
            <p className="text-xl md:text-2xl mb-4 text-blue-100">
              {slides[currentSlide].subtitle}
            </p>
            <p className="text-lg mb-8 text-blue-200">
              {slides[currentSlide].description}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
              <Link to="/products">
                <Button variant="primary" size="lg">
                  Explore Products
                </Button>
              </Link>
              <Link to="/contact">
                <Button variant="outline" size="lg">
                  Contact Us
                </Button>
              </Link>
            </div>
            <div className="text-lg text-blue-100 animate-pulse">
              Trusted Quality · Precision Manufacturing · Customer Commitment
            </div>
          </div>
        </div>

        {/* Slider Indicators */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-20">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                index === currentSlide ? 'bg-white' : 'bg-white/50'
              }`}
            />
          ))}
        </div>

        {/* Slider Navigation */}
        <button
          onClick={() => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)}
          className="absolute left-6 top-1/2 transform -translate-y-1/2 text-white/70 hover:text-white text-3xl z-20 cursor-pointer"
        >
          <i className="ri-arrow-left-line"></i>
        </button>
        <button
          onClick={() => setCurrentSlide((prev) => (prev + 1) % slides.length)}
          className="absolute right-6 top-1/2 transform -translate-y-1/2 text-white/70 hover:text-white text-3xl z-20 cursor-pointer"
        >
          <i className="ri-arrow-right-line"></i>
        </button>
      </section>

      {/* Highlights Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Why Choose Us</h2>
            <p className="text-xl text-gray-600">Excellence in every aspect of chemical manufacturing</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {highlights.map((item, index) => (
              <Card key={index} className="p-8 text-center group">
                <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-blue-600 to-blue-800 rounded-full flex items-center justify-center text-white text-2xl group-hover:scale-110 transition-transform duration-300">
                  <i className={item.icon}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Our Strengths</h2>
            <p className="text-xl text-gray-600">What makes us the preferred choice for Light Magnesium Carbonate</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((item, index) => (
              <div key={index} className="text-center group">
                <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-blue-100 to-blue-200 rounded-full flex items-center justify-center text-blue-800 text-3xl group-hover:scale-110 transition-transform duration-300">
                  <i className={item.icon}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Applications Preview */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Industry Applications</h2>
            <p className="text-xl text-gray-600">Our Light Magnesium Carbonate serves diverse industries</p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 mb-12">
            {applications.map((app, index) => (
              <div key={index} className="text-center group">
                <div className="w-16 h-16 mx-auto mb-4 bg-white rounded-full flex items-center justify-center text-blue-600 text-2xl shadow-lg group-hover:shadow-xl group-hover:scale-110 transition-all duration-300">
                  <i className={app.icon}></i>
                </div>
                <p className="text-sm font-medium text-gray-700">{app.name}</p>
              </div>
            ))}
          </div>
          
          <div className="text-center">
            <Link to="/applications">
              <Button variant="primary" size="lg">
                View All Applications
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* About Preview Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-800 mb-6">Welcome to Shree Govardhan Chemicals</h2>
              <p className="text-lg text-gray-600 mb-6">
                Shree Govardhan Chemicals is a reputed manufacturer of Light Magnesium Carbonate (MgCO3) trusted by domestic clients across India.
              </p>
              <p className="text-lg text-gray-600 mb-6">
                Based in Bhavnagar, Gujarat, we operate our own manufacturing unit equipped with modern infrastructure, advanced machinery, and strict quality assurance standards.
              </p>
              <div className="grid grid-cols-2 gap-4 mb-8">
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-green-600 text-xl"></i>
                  <span className="text-gray-700">Own Manufacturing Unit</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-green-600 text-xl"></i>
                  <span className="text-gray-700">Quality Innovation</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-green-600 text-xl"></i>
                  <span className="text-gray-700">Experienced Team</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-green-600 text-xl"></i>
                  <span className="text-gray-700">Customer-Centric</span>
                </div>
              </div>
              <Link to="/about">
                <Button variant="primary">Know More</Button>
              </Link>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=modern%20chemical%20manufacturing%20plant%20facility%2C%20industrial%20equipment%2C%20quality%20control%20laboratory%2C%20professional%20workers%20in%20safety%20gear%2C%20clean%20manufacturing%20environment%2C%20Gujarat%20India%20industrial%20setting&width=600&height=400&seq=about-preview&orientation=landscape"
                alt="Manufacturing Facility"
                className="rounded-xl shadow-2xl object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-gradient-to-r from-blue-800 to-blue-900 text-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold mb-2">15+</div>
              <div className="text-blue-200">Years Experience</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">500+</div>
              <div className="text-blue-200">Satisfied Clients</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">99.9%</div>
              <div className="text-blue-200">Product Purity</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">24/7</div>
              <div className="text-blue-200">Customer Support</div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
